module.exports = __webpack_public_path__ + "static/media/icon2.1f7a53e8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon2.jpeg
// module id = 197
// module chunks = 0